export const PRIOR_PREFIX = "__PRIOR__::";

export const getLookupKey = (exposure) => {
  const rp = exposure?._REGION_PERIL ?? "";
  const desc = exposure?._DESCRIPTION ?? "";
  return `${rp}::${desc}`;
};

export const getExposures = ({
  manualExposures,
  pricingById,
  priorManualPricing,
}) => {
  const priorByLookupKey = {};
  Object.values(priorManualPricing).forEach((obj) => {
    const key = getLookupKey(obj);
    if (key !== "::") priorByLookupKey[key] = obj;
  });

  const currentExposures = manualExposures.map((exposure) => {
    const pricing = pricingById?.[exposure.id] ?? {};
    const rp = pricing?._REGION_PERIL ?? exposure?._REGION_PERIL;
    const desc = pricing?._DESCRIPTION ?? exposure?._DESCRIPTION;
    const key = getLookupKey({ _REGION_PERIL: rp, _DESCRIPTION: desc });
    const expiring = priorByLookupKey?.[key]?._VALUE;
    return {
      ...exposure,
      ...pricing,
      _EXPIRING_VALUE: expiring,
    };
  });

  const currentLookupKeys = new Set(
    currentExposures.map(getLookupKey).filter((k) => k !== "::")
  );

  const priorOnlyRows = Object.values(priorByLookupKey)
    .filter((obj) => {
      const key = getLookupKey(obj);
      return obj && key !== "::" && !currentLookupKeys.has(key);
    })
    .map((obj) => {
      const key = getLookupKey(obj);
      return {
        id: `${PRIOR_PREFIX}${key}`,
        _REGION_PERIL: obj._REGION_PERIL,
        _DESCRIPTION: obj._DESCRIPTION,
        _EXPIRING_VALUE: obj._VALUE,
      };
    });

  return [...currentExposures, ...priorOnlyRows];
};
